import { UA_PATTERNS, APP_VERSION_PATTERN } from './botConfig';
let pattern = null;
function getUAPattern() {
    if (pattern) {
        return pattern;
    }
    pattern = new RegExp(new RegExp(UA_PATTERNS.join('|'), 'i'), 'i');
    return pattern;
}
function isBotUserAgent(userAgent) {
    if (!userAgent) {
        return false;
    }
    try {
        return getUAPattern().test(userAgent);
    } catch (err) {
        // Some old browsers may not support the regular expressions we are using,
        // such as negative lookbehind ((?<! )) in old versions of Safari
        return false;
    }
}
function isBotAppVersion(appVersion) {
    if (!appVersion) {
        return false;
    }
    return APP_VERSION_PATTERN.test(appVersion);
}
function isBotWebGLSignal() {
    const canvasElement = document.createElement('canvas');
    if (typeof canvasElement.getContext !== 'function') {
        return false;
    }
    const webGLContext = canvasElement.getContext('webgl');
    if (webGLContext === null) {
        return false;
    }
    if (typeof webGLContext.getParameter !== 'function') {
        return false;
    }
    try {
        const vendor = webGLContext.getParameter(webGLContext.VENDOR);
        const renderer = webGLContext.getParameter(webGLContext.RENDERER);
        return vendor === 'Brian Paul' && renderer === 'Mesa OffScreen';
    } catch (err) {
        if (err instanceof TypeError && err.message.includes('getParameter')) {
            // getParameter function might not be present
            // and "typeof webGLContext.getParameter !== 'function'" doesn't always catch it"
            return false;
        }
        throw err;
    }
}
let cachedIsBotResult = null;
export function isBot({ userAgent , appVersion  } = navigator, { cache  } = {
    cache: true
}) {
    if (cache && cachedIsBotResult !== null) {
        return cachedIsBotResult;
    }
    const result = isBotUserAgent(userAgent) || isBotAppVersion(appVersion) || isBotWebGLSignal();
    if (cache) {
        cachedIsBotResult = result;
    }
    return result;
}

//# sourceMappingURL=botDetect.js.map